import React, { useState } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import PrimaryButton from '../button/PrimaryButton';
import studentIcon from '../../styles/img/icons/student.svg';

export const CouponCard = ({ data, onActivate, onDeactivate, store, cartItems, activateCouponLoadingId }) => {
  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    return format(new Date(timestamp), 'dd/MM/yyyy', { locale: fr });
  };
  const value = data?.valeur?.valeur || 0;
  const expiryDate = data?.periode_validite?.fin || null;
  const remplaceDot = value?.toString().replace('.', ',');

  let isActivated = cartItems?.coupon?.id_coupon === data?.id_coupon;
  return (
    <div className={`relative w-full mx-auto my-2  !rounded-[14px] shadow-[0px_3px_15px_0px_rgba(0,0,0,0.1)] overflow-hidden bg-white border border-gray-200 transition-all duration-300 
            ${isActivated ? '!border-green-500 !border-4 !bg-green-50' : ''}`}>

      {isActivated && (
        <div
          className="absolute top-0 right-0 bg-green-500 text-white px-3 py-1 !rounded-bl-[14px] text-[12px] font-medium geomanistMedium z-10">
          Activé
        </div>
      )}

      <div className="flex flex-row">
        <div className="w-1/4 p-4 flex flex-col items-center justify-center py-4">
          <img src={studentIcon} alt="coupon" className="w-[38px] h-full object-contain" />
          {store?.logo && <img src={store?.logo} alt="coupon" className="w-full h-full object-contain" />}
        </div>
        <div className="w-3/4 p-4 flex flex-col items-start justify-center gap-2 py-8">
          <div className="flex items-center">
            {remplaceDot >= 0 && (
              <span className={`text-5xl font-medium opacity-90  geomanistMedium transition-transform duration-300
                            ${isActivated ? '!scale-110 ' : ''}`}>
                              {remplaceDot === "0" ? (
                                <>-10%</>
                                //HARDCODE TO CHANGE
                              ) : (
                                <>-{remplaceDot}€</>
                              )}
                          </span>
            )}
          </div>
          <div className="text-black opacity-50 text-[14px] mt-1 font-semibold geomanistRegular">
            {data.libelle}
          </div>
          <div className="text-[12px] opacity-60 geomanistRegular">
            Valable jusqu'au {formatDate(expiryDate)}
          </div>
        </div>

        <div
          className="w-1/2 flex flex-col  items-center justify-center p-4 border-dashed border-gray-300 border-t-0 border-r-0 border-b-0 border-l-2">

          {isActivated ? (
            <PrimaryButton
              label={'Désactiver'}
              onClick={() => onDeactivate(data)}
              className="!shadow-none h-full max-h-[60px]"
              isLoading={activateCouponLoadingId === data?.id_coupon}
              disabledWithoutColorChange={activateCouponLoadingId}
            />
          ) : (
            <PrimaryButton
              label={'Activer'}
              onClick={() => onActivate(data)}
              className="!shadow-none h-full max-h-[60px]"
              isLoading={activateCouponLoadingId === data?.id_coupon}
              disabledWithoutColorChange={activateCouponLoadingId}
            />
          )}
        </div>
      </div>

      {/* Indicateur visuel pour l'état activé */}
      {isActivated && (
        <div className="absolute -left-6 -top-6 w-12 h-12 bg-green-500 rotate-45 opacity-10"></div>
      )}
    </div>
  );
};
